/* ──────────────────────────────────────────────────────────────
   src/constants/colors.ts
   Colores de estados: DB-first (catálogo) con fallback gris
   ────────────────────────────────────────────────────────────── */

import { getEstadosReservaCatalog, resolveEstado } from "./enums";

/** Devuelve el color del catálogo en memoria.
 *  Acepta code (CONFIRMED, PENDING_..., CANCEL_...) o label/descripcion.
 *  Si no hay color configurado, devuelve gris por defecto. */
export function getEstadoColor(codeOrLabel?: string, defaultColor = "#9e9e9e"): string {
  if (!codeOrLabel) return defaultColor;
  const e = resolveEstado(codeOrLabel);
  return e?.color || defaultColor;
}

/** Construye un mapa descripción → color desde el catálogo actual. */
export function buildEstadoColorMap(): Record<string, string> {
  const map: Record<string, string> = {};
  const cat = getEstadosReservaCatalog();
  for (const e of cat) {
    const key = e.descripcion ?? e.code;
    if (key) map[key] = e.color || "#9e9e9e";
  }
  return map;
}

/** Compat: snapshot estático; usa getEstadoColor en tiempo real si puedes. */
export const COLOR_ESTADO: Record<string, string> = buildEstadoColorMap();
